if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('card-port-switcher.js')) {
  window.Eurus.loadedScript.add('card-port-switcher.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCardPortSwitcher', (ports, initialKey) => ({
      ports: ports || {},
      active: initialKey || 'b',

      select(key) {
        if (!this.ports[key] || this.active === key) return;
        this.active = key;
        this.apply(key);
      },

      apply(key) {
        const product = this.ports[key];
        const card = this.$el.closest('.card-product-kik, .card-product');
        if (!product || !card) return;

        card.querySelectorAll('.x-card-title a').forEach((link) => {
          link.textContent = product.title;
          link.setAttribute('href', product.url);
        });

        const media = card.querySelector('a.x-labels-data');
        if (media) {
          media.setAttribute('href', product.url);
          media.setAttribute('aria-label', product.title);
          media.querySelectorAll('img').forEach((img) => {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.setAttribute('src', product.image);
            img.setAttribute('alt', product.title);
          });
        }

        const priceRoot = card.querySelector('.x-card-price');
        if (priceRoot) {
          const target = priceRoot.querySelector('.target-price');
          if (target && product.priceCents != null) {
            target.textContent = String(product.priceCents);
          }

          const compareTarget = priceRoot.querySelector('.target-compare-at-price');
          if (compareTarget) {
            compareTarget.textContent =
              product.compareAtCents != null && product.compareAtCents > product.priceCents
                ? String(product.compareAtCents)
                : '';
          }

          const visible = priceRoot.querySelector('p.price span, .price-sale, .price-item--regular, .price-item--sale');
          if (visible) {
            visible.textContent = product.price;
          } else {
            const nested = priceRoot.querySelector('p.price');
            if (nested) nested.textContent = product.price;
          }

          const compareVisible = priceRoot.querySelector('.price-compare, .price-item--regular.line-through, s.price-item');
          if (compareVisible) {
            if (product.compareAtPrice) {
              compareVisible.textContent = product.compareAtPrice;
              compareVisible.classList.remove('hidden');
            } else {
              compareVisible.textContent = '';
              compareVisible.classList.add('hidden');
            }
          }
        }

        const badge = card.querySelector('.kik_discount_badge');
        if (badge) {
          if (product.discountLabel) {
            badge.classList.remove('hidden');
            const label = badge.querySelector('span');
            if (label) label.textContent = product.discountLabel;
          } else {
            badge.classList.add('hidden');
          }
        }

        const usp = card.querySelector('.x-card-usp');
        if (usp && Array.isArray(product.usps)) {
          usp.innerHTML = product.usps
            .map((item) => `<li>${this.escapeHtml(item)}</li>`)
            .join('');
        }

        card.querySelectorAll('form input[name="id"]').forEach((input) => {
          input.value = String(product.variantId);
        });

        card.querySelectorAll('.current-variant').forEach((node) => {
          node.textContent = String(product.variantId);
        });

        card.querySelectorAll('.kik_product_cart button[type="submit"], form[data-type="add-to-cart-form"] button[type="submit"]').forEach((button) => {
          button.disabled = !product.available;
        });
      },

      escapeHtml(value) {
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      },
    }));
  });
}
